export const SET_TEACHERS = 'SET_TEACHERS';
export const SET_TEACHER_ID = 'SET_TEACHER_ID';
export const REMOVE_TEACHER_ID = 'REMOVE_TEACHER_ID';
export const SET_TEACHER = 'SET_TEACHER';
export const REMOVE_TEACHER = 'REMOVE_TEACHER';
export const SET_ALL_TEACHERS = 'SET_ALL_TEACHERS';


// WEBPACK FOOTER //
// ./src/store/modules/teachers/mutations.js